export class LocationDepricated {
    locationCode: string;
    country: string;
    region: string;
    type: string;
    locationName: string;
    city: string;
}
